export class TipoBeneficio {
  id: number;
  tipoAuxilio: string;
  descAuxilio: string;
}
